import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import safeStorage from '../utils/safeStorage';

const gtag = (...args) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show banner only if user hasn't made a choice yet
    if (!safeStorage.getItem('cookie_consent')) {
      // Small delay so it doesn't flash on initial paint
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const handleAccept = () => {
    safeStorage.setItem('cookie_consent', 'granted');
    gtag('consent', 'update', { analytics_storage: 'granted' });
    setVisible(false);
  };

  const handleDecline = () => {
    safeStorage.setItem('cookie_consent', 'denied');
    gtag('consent', 'update', { analytics_storage: 'denied' });
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: 'calc(100% - 32px)',
      maxWidth: '600px',
      background: '#1a0533',
      color: '#e9e3f5',
      borderRadius: '16px',
      padding: '16px 20px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
      flexWrap: 'wrap',
      animation: 'slideUp 0.3s ease',
    }}>
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateX(-50%) translateY(20px); }
          to   { opacity: 1; transform: translateX(-50%) translateY(0);    }
        }
      `}</style>

      {/* Text */}
      <div style={{ flex: 1, minWidth: '220px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
          <span style={{ fontSize: '16px' }}>🍪</span>
          <span style={{ fontWeight: 700, fontSize: '14px', color: '#fff' }}>We use cookies</span>
        </div>
        <p style={{ fontSize: '12px', color: '#b39ddb', margin: 0, lineHeight: 1.5 }}>
          We use Google Analytics to improve your experience. No ads, no third-party tracking.{' '}
          <Link to="/privacy" style={{ color: '#c4a8ff', textDecoration: 'underline' }}>
            Privacy Policy
          </Link>
        </p>
      </div>

      {/* Buttons */}
      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
        <button
          onClick={handleDecline}
          style={{
            padding: '7px 16px',
            borderRadius: '20px',
            border: '1px solid rgba(255,255,255,0.2)',
            background: 'transparent',
            color: '#b39ddb',
            fontSize: '13px',
            fontWeight: 600,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          Decline
        </button>
        <button
          onClick={handleAccept}
          style={{
            padding: '7px 20px',
            borderRadius: '20px',
            border: 'none',
            background: 'linear-gradient(135deg, #6f42c1, #9b59b6)',
            color: '#fff',
            fontSize: '13px',
            fontWeight: 700,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            boxShadow: '0 2px 8px rgba(111,66,193,0.4)',
          }}
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
